// extracted by mini-css-extract-plugin
module.exports =  {"phone":"_5b10bb2305--phone--JfvMm"};